export const version = "1.0.2-daily-20260721-0";
export const channel = "daily";
export const gitcommit = "fbc05ea4a";
